<template>
  <div class="user-events-calendar-component">
    <div class="filters mb-4 d-flex flex-wrap align-items-end">
      <div class="form-group me-3 mb-25">
        <label for="search" class="me-2">Search</label>
        <input v-model="search" type="text" class="form-control" id="search" @keyup.enter="getEvents()" :disabled="loading">
      </div>

      <button @click="getEvents()" type="button" class="btn btn-primary mb-25" :disabled="loading">
        Search
      </button>

      <button v-if="filters" @click="resetFilters()" type="button" class="ms-3 mb-25 btn btn-danger">Reset Filters</button>

      <a href="/admin/calendar/create" class="ms-3 mb-25 btn btn-success">Create</a>

      <div v-if="loading" class="ms-3 mb-25 spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="d-flex">
      <div class="calendar">
        <v-calendar
          :attributes="attrs"
          ref="calendar"
          is-dark
          title-position="left"
          color="green"
          @dayclick="selectDate"
          @update:from-page="getEvents"
          @update:to-page="getEvents"
        />
        <div class="key d-flex align-items-center mt-2">
          <div class="circle today"></div>
          <span class="me-4">Today</span>
          <div class="circle appointment"></div>
          <span>Appointment</span>
        </div>
      </div>

      <div class="d-flex flex-column">
        <h4 v-if="selectedDate" class="ms-4">{{ selectedDate.ariaLabel }}</h4>

        <div v-if="selectedEvents" class="d-flex flex-wrap ms-4">
          <div v-for="selectedEvent in selectedEvents" :key="selectedEvent.id" class="card me-3 mb-3">
            <div class="card-body">
              <p>
                <strong>User:</strong> {{ selectedEvent.user.name }}<br>
                <strong>Email:</strong> {{ selectedEvent.user.email }}<br>
                <br>
                <strong>Name:</strong> {{ selectedEvent.name }}<br>
                <strong>Starts:</strong> {{ selectedEvent.starts_at | moment("llll") }}<br>
                <strong>Ends:</strong> {{ selectedEvent.ends_at | moment("llll") }}
              </p>
              <a :href="'/admin/calendar/' + selectedEvent.id + '/edit'" class="btn btn-primary">View Event</a>
            </div>
          </div>

          <div v-if="!selectedEvents || selectedEvents.length < 1" class="alert alert-warning">
            There are no events on this day.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      attrs: null,
      search: null,
      filters: null,
      calendar: null,
      selectedDate: null,
      selectedEvents: null,
      currentYear: null,
      currentMonth: null,
    };
  },

  props: {
    // preloadUser: {
    //   type: Object,
    //   default: null,
    // },
  },

  created() {
    // Get reference to the calendar component.
    this.calendar = this.$refs.calendar;

    // Load get params.
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('filters[search]')) {
      this.search = urlParams.get('filters[search]');
    }

    this.setFilters();

    this.getEvents();
  },

  methods: {
    selectDate(data) {
      this.selectedDate = data;
      this.selectedEvents = null;
      this.loading = true;

      let ids = [];
      for (const attr in data.attributes) {
        if (data.attributes[attr].key === 'today') {
          continue;
        }

        ids.push(data.attributes[attr].key);
      }

      axios.post(window.api_url + '/admin/user_events/details', {
        ids: ids,
      })
      .then(res => {
        if (res.data && res.data.success) {
          this.selectedEvents = res.data.user_events;
        }
      })
      .catch(err => {
        //
      })
      .finally(() => {
        this.loading = false;
      });
    },

    setFilters() {
      if (this.search !== null) {
        this.filters = {
          search: this.search,
        };
      } else {
        this.filters = null;
      }
    },

    handlePushState() {
      let pageUrl = '?';

      // Add filters.
      for (const filter in this.filters) {
        if (this.filters[filter] === null) {
          continue;
        }

        if (pageUrl !== '?') {
          pageUrl += '&';
        }

        pageUrl += `filters[${filter}]=${encodeURIComponent(this.filters[filter])}`;
      }

      window.history.pushState('', '', pageUrl);
    },

    getEvents(data = null) {
      this.loading = true;
      this.attrs = null;
      this.setFilters();
      this.handlePushState();

      this.currentYear = data ? data.year : this.currentYear;
      this.currentMonth = data ? data.month : this.currentMonth;

      axios.post(window.api_url + '/admin/user_events/calendar', {
          filters: this.filters,
          date: {
            month: this.currentMonth,
            year: this.currentYear,
          },
        })
        .then(res => {
          if (res.data && res.data.success) {
            this.attrs = res.data.attrs;
          }
        })
        .catch(err => {
          //
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetFilters() {
      this.search = null;
      this.getEvents();
    },
  },
};
</script>
